import React, { useState, useEffect } from 'react';
import { NotificationPermissionService } from '../../services/notificationPermissionService';

interface NotificationStatusProps {
  isEnabled: boolean;
  onToggle: (enabled: boolean) => void;
}

export const NotificationStatus: React.FC<NotificationStatusProps> = ({ isEnabled, onToggle }) => {
  const [permissionStatus, setPermissionStatus] = useState<NotificationPermission | 'unsupported'>('default');

  useEffect(() => {
    setPermissionStatus(NotificationPermissionService.getPermissionStatus());
  }, [isEnabled]);

  const handleToggle = async (checked: boolean) => {
    if (checked) {
      const hasPermission = await NotificationPermissionService.requestPermission();
      if (hasPermission) {
        onToggle(true);
        setPermissionStatus('granted');
        // Envoyer une notification de test
        NotificationPermissionService.sendTestNotification();
      } else {
        onToggle(false);
        setPermissionStatus('denied');
      }
    } else {
      onToggle(false);
    }
  };

  const getStatusText = () => {
    switch (permissionStatus) {
      case 'granted':
        return '✅ Notifications autorisées';
      case 'denied':
        return '❌ Notifications bloquées';
      case 'unsupported':
        return '⚠️ Non supportées par ce navigateur';
      default:
        return '⏳ Permission non demandée';
    }
  };

  const getStatusColor = () => {
    switch (permissionStatus) {
      case 'granted':
        return 'text-green-400';
      case 'denied':
        return 'text-red-400';
      case 'unsupported':
        return 'text-yellow-400';
      default:
        return 'text-gray-400';
    }
  };

  return (
    <div className="flex items-center justify-between p-4 rounded-lg bg-emerald-950/30 border border-emerald-800/30">
      <div>
        <h3 className="font-medium text-emerald-200">Notifications push</h3>
        <p className="text-sm text-emerald-400/70">Recevoir des notifications pour les activités importantes</p>
        <div className="mt-1">
          <span className={`text-xs ${getStatusColor()}`}>
            {getStatusText()}
          </span>
        </div>
      </div>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={isEnabled && permissionStatus === 'granted'}
          onChange={(e) => handleToggle(e.target.checked)}
          className="sr-only peer"
          disabled={permissionStatus === 'unsupported'}
        />
        <div className="w-12 h-6 bg-gray-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-6 peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gradient-to-r peer-checked:from-emerald-500 peer-checked:to-cyan-500 peer-disabled:opacity-50"></div>
      </label>
    </div>
  );
};
